import React from 'react';

import { ActionButton } from '@alpha/ui-lib/ui/button';
import { Typography } from '@alpha/ui-lib/ui/Typography';

import Warning from '../../../../../../assets/warning.svg';
import APModal from '../../../../../Modals/APModal/APModal';
import useStyles from '../../../RejectPaymentModal/index.styles';
import t from 'utils/translationHelper';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Trans } from 'react-i18next';

type Props = {
  open: boolean;
  handleClose: () => void;
  handleSubmit: () => void;
}

const PaymentIncompleteWarningModal: React.FC<Props> = ({ open, handleSubmit, handleClose }: Props) => {

  const styles = useStyles();

  return (
    <APModal.Container open={open} onClose={handleClose}>
      <APModal.Wrapper className={styles.container}>
        <div style={{ textAlign: 'left', padding: '0px 8px', width: '520px', maxWidth: '100%' }}>
          <div style={{ marginBottom: '36px' }}>
            <Typography style={{ fontWeight: '800', marginBottom: '16px', fontSize: '16px' }}>
            <FontAwesomeIcon icon={faExclamationTriangle} style={{ fontSize: '16px', display: 'inline-block', color: '#cf753f', marginRight: '8px' }} />
              {t('payment_incomplete')}</Typography>
              <Trans 
              components={{ strong: <strong /> }} 
              children={'you_have_an_incomplete_payment_option'}
               />
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <ActionButton style={{ width: '120px', backgroundColor: '#F7F7F7', color: '#212529' }} onClick={handleClose}>{t('go_back')}</ActionButton>
            <ActionButton fullWidth style={{ marginLeft: '16px' }} onClick={handleSubmit}>{t('acknowledge')}</ActionButton>
          </div>
        </div>
      </APModal.Wrapper>
    </APModal.Container>
  );
};

export default PaymentIncompleteWarningModal;
